export const FILTERS = {
  STATUS_PLACEHOLDER: "Status",
  SESSION_PLACEHOLDER: "Session Number (e.g. 1, 2)",
  SOURCE_STATUS: "status",
  SOURCE_SESSION: "session_number",
  SOURCE_TOTAL_ATTENDANCE: "total_attendance_range",
  SOURCE_TOTAL_ATTENDANCE_PERCENTAGE: "total_attendance_percentage_range",
  SOURCE_ATTENDANCE_FROM: "attendance_from",
  SOURCE_ATTENDANCE_TO: "attendance_to",
  SOURCE_TOTAL_ATTENDED_FROM: "total_attended_from",
  SOURCE_TOTAL_ATTENDED_TO: "total_attended_to",
  SOURCE_MINUTES_FROM: "minutes_from",
  SOURCE_MINUTES_TO: "minutes_to",
  SOURCE_SESSION_DATE: "session_date",
  METRIC_PLACEHOLDER: "Select Metric",
  FROM_LABEL: "From",
  TO_LABEL: "To",
  APPLY_LABEL: "Apply",
  CLEAR_ALL_LABEL: "Clear Filter",
  DATE_PLACEHOLDER: "Select Session Date",
  ZERO_PLACEHOLDER: "0",
  MAX_PLACEHOLDER: "Max",
  HUNDRED_PLACEHOLDER: "100",
  METRIC_OPTIONS: {
    ATTENDANCE_PCT: "attendance_pct",
    ATTENDANCE_COUNT: "attendance_count",
    STATUS: "status",
    SESSION_DATE: "session_date",
  },
};
